import { render, staticRenderFns } from "./VerifyEmail.vue?vue&type=template&id=24c5ff62"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24c5ff62')) {
      api.createRecord('24c5ff62', component.options)
    } else {
      api.reload('24c5ff62', component.options)
    }
    module.hot.accept("./VerifyEmail.vue?vue&type=template&id=24c5ff62", function () {
      api.rerender('24c5ff62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/auth/VerifyEmail.vue"
export default component.exports